var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#627EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28027 2.25V7.23937L13.4973 9.12375L9.28027 2.25Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28012 2.25L5.0625 9.12375L9.28012 7.23937V2.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28027 12.3572V15.7474L13.5001 9.90918L9.28027 12.3572Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28012 15.7474V12.3566L5.0625 9.90918L9.28012 15.7474Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28027 11.572L13.4973 9.12348L9.28027 7.24023V11.572Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 9.12348L9.28012 11.572V7.24023L5.0625 9.12348Z",
    fill: "white",
    fillOpacity: 0.602
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIcon);
export default __webpack_public_path__ + "static/media/ethIcon.2e4dbbd814492b568ee3c44a561f0fc9.svg";
export { ForwardRef as ReactComponent };